export default function getExperience(yearsOfExperience: number) {
  switch(yearsOfExperience) {
    case 0:
      return 'Première expérience acceptée';
    case 1:
      return '1 an minimum';
    default:
      return `${yearsOfExperience} ans minimum`;
  }
}